/**
 * TEMPORARY_CRAVE_USER_TRENDS_GATE: Remove this gate when trend indicators are
 * ready for all insight users. Change the return value to `true` to enable them.
 */
export const shouldShowInsightsTrends = (isCraveUser: boolean): boolean => isCraveUser;
